import { useMemo } from "react"
import useSWR from "swr"
import { fetchApiGateway } from "@nova/fetch-api-gateway"

export const useAircraftFullDetail = ({
    orgId,
    callsign,
}: {
    orgId: string | undefined
    callsign: string | undefined
}) => {
    const swr = useSWR(
        orgId && callsign ? ["adsb-full-detail", callsign] : null,
        () =>
            fetchApiGateway("get /org/:orgId/adsb/:callsign", {
                params: { orgId: orgId!, callsign: callsign! },
            }),
        { revalidateOnFocus: false, dedupingInterval: 10_000 }
    )

    const data = useMemo(() => swr.data?.detail, [swr.data])
    return { ...swr, data }
}
